const FormFields = {
    // DATOS GENERALES / PERSONALES //Validado
    general_data: {
        nombres: {
            isRequired: true,
            valueValidate: '',
            validate: '',
         
            hasdata: false,
            require_msg: 'nombre es obligatorio',
            validate_msg: ''
        },
        apellidoPaterno: {
            isRequired: true,
            valueValidate: '',
            value: '',
           
            hasdata: false,
            require_msg: 'apellido paterno es obligatorio',
            validate_msg: ''
        },
        apellidoMaterno: {
            isRequired: true,
            valueValidate: '',
            value: '',
        
            hasdata: false,
            require_msg: 'apellido materno es obligatorio',
            validate_msg: ''
        },
        fechaNacimiento: {
            isRequired: true,
            value: '',
            hasdata: false,
            require_msg: 'fecha de nacimeinto es obligatorio',
            validate_msg: ''
        },
        edad: {
            isRequired: true,
            value: '',
            valueValidate: 0,
            hasdata: true,
            require_msg: '',
            validate_msg: ''
        },
        tipoDocPostulante: {
            isRequired: true,
            valueValidate: -1,
            value: '',
            hasdata: false,
            require_msg: 'tipo de documento es obligatorio',
            validate_msg: ''
        },
        nroDocumento: {
            isRequired: true,
            value: '',
            valueValidate:'',
            hasdata: false,
            require_msg: 'número de documento es obligatorio',
            validate_msg: ''
        },
        nroUbigeoDNI: {
            isRequired: false,
            value: '',
            valueValidate: '',
            hasdata: true,
            require_msg: 'ubigeo es obligatorio',
            validate_msg: ''
        },
        genero: {
            isRequired: true,
            valueValidate: -1,
            value: '',
            hasdata: false,
            require_msg: 'Género es obligatorio',
            validate_msg: ''
        },
        estadoCivil: {
            isRequired: true,
            valueValidate: -1,
            value: '',
            hasdata: false,
            require_msg: 'estado civil es obligatorio',
            validate_msg: ''
        },
        celular: {
            isRequired: true,
            valueValidate: '',
            value: '',
            hasdata: false,
            require_msg: 'celular es obligatorio',
            validate_msg: ''
        },
        emailPersonal: {
            value: '',
            is_require: true,
            hasdata: false,
            require_msg: 'email personal es obligatorio',
            validate_msg: 'ingresa un email correcto'
        },
        nacionalidad: {
            isRequired: false,
            value: '',
            hasdata: false,
            require_msg: 'Nacionalidad es obligatorio',
            validate_msg: ''
        },
        paisResidencia: {
            isRequired: true,
            valueValidate: -1,
            value: '',
            hasdata: false,
            require_msg: 'país de residencia es obligatorio',
            validate_msg: ''
        },
        idDepartamento: {
            isRequired: false,
            valueValidate: -1,
            value: '',
            hasdata: false,
            require_msg: 'departamento es obligatorio',
            validate_msg: ''
        },
        idProvincia: {
            isRequired: false,
            valueValidate: -1,
            value: '',
            hasdata: false,
            require_msg: 'provincia es obligatorio',
            validate_msg: ''
        },
        idDistrito: {
            isRequired: false,
            valueValidate: -1,
            value: '',
            hasdata: false,
            require_msg: 'distrito es obligatorio',
            validate_msg: ''
        },
        direccion: {
            isRequired: true,
            valueValidate: '',
            value: '',
            hasdata: false,
            require_msg: 'direccion es obligatorio',
            validate_msg: ''
        },
        nivelAcademico: {
            isRequired: true,
            valueValidate: -1,
            value: '',
            hasdata: false,
            require_msg: 'nivel académico es obligatorio',
            validate_msg: ''
        },
        institucionProcedencia: {
            isRequired: false,//Se valida internamente
            valueValidate: '',
            value: '',
            hasdata: false,
            require_msg: 'institucion es obligatorio',
            validate_msg: ''
        },
        tipoDiscapacidad: {
            value: '',
            isRequired: true,
            hasdata: false,
            require_msg: 'tipo de discapacidad es obligatorio',
            validate_msg: ''
        },
        discapacidad: {
            value: '',
            isRequired: false,
            hasdata: false,
            require_msg: 'discapacidad es obligatorio',
            validate_msg: ''
        },
        identidadLengua: {
            isRequired: true,
            valueValidate: -1,
            value: '',
            hasdata: false,
            require_msg: 'Lengua indígena u originaria es obligatorio',
            validate_msg: ''
        },
        identidadPueblo: {
            isRequired: true,
            valueValidate: -1,
            value: '',
            hasdata: false,
            require_msg: 'Pueblo Indígena u originario es obligatorio',
            validate_msg: ''
        },
    },

    aditional_data: {
        tipoIngresos: {
            value: '',
            isRequired: true,
            hasdata: false,
            require_msg: 'selecciona un tipo de ingreso',
            validate_msg: ''
        },
        ingresosProfesionales: {
            value: '',
            isRequired: true,
            hasdata: false,
            require_msg: 'ingreso profesional es obligatorio',
            validate_msg: ''
        },
        ingresosOtros: {
            value: '',
            isRequired: false,
            hasdata: false,
            require_msg: 'otros ingresos es obligatorio',
            validate_msg: ''
        },
        ingresosFamiliaresMes: {
            value: '',
            isRequired: true,
            hasdata: false,
            require_msg: 'ingreso familiares es obligatorio',
            validate_msg: ''
        },
        egresosFamiliaresMes: {
            value: '',
            isRequired: true,
            hasdata: false,
            require_msg: 'egresos familiares es obligatorio',
            validate_msg: ''
        },
    },

    spouse_data: {
        noTengoConyugue: {
            value: '',
            isRequired: false,
            valueValidate: '',
            hasdata: false,
            require_msg: '',
            validate_msg: ''
        },
        conyugueTelefonoFijo: {
            value: '',
            isRequired: false,
            hasdata: false,
            require_msg: '',
            validate_msg: ''
        },
        conyugueNombres: {
            value: '',
            isRequired: true,
            valueValidate: '',
            hasdata: false,
            require_msg: 'Nombre es obligatorio',
            validate_msg: ''
        },
        conyugueApellidoPaterno: {
            value: '',
            isRequired: true,
            valueValidate: '',
            hasdata: false,
            require_msg: 'apellido paterno es obligatorio',
            validate_msg: ''
        },
        conyugueApellidoMaterno: {
            value: '',
            isRequired: false,
            hasdata: false,
            require_msg: 'apellido materno es obligatorio',
            validate_msg: ''
        },
        conyugueFechaNacimiento: {
            value: '',
            isRequired: false,
            hasdata: false,
            require_msg: 'fecha de nacimiento es obligatorio',
            validate_msg: ''
        },
        conyugueTipoDoc: {
            value: '',
            isRequired: false,
            hasdata: false,
            require_msg: 'selecciona un tipo de documento',
            validate_msg: ''
        },
        conyugueNroDocumento: {
            value: '',
            isRequired: true,
            valueValidate: '',
            hasdata: false,
            require_msg: 'numero de documento es obligatorio',
            validate_msg: ''
        },
        conyugueCelular: {
            value: '',
            isRequired: true,
            valueValidate: '',
            hasdata: false,
            require_msg: 'celular es obligatorio',
            validate_msg: ''
        },
        conyugueEmailPersonal: {
            value: '',
            isRequired: true,
            valueValidate: '',
            hasdata: false,
            require_msg: 'email es obligatorio',
            validate_msg: ''
        },
        conyuguelCentroLaboral: {
            value: '',
            isRequired: false,
            hasdata: false,
            require_msg: 'centro Laboral es obligatorio',
            validate_msg: ''
        },
        conyugueAniosPuesto: {
            value: '',
            isRequired: false,
            hasdata: false,
            require_msg: 'años en puesto es obligatorio',
            validate_msg: ''
        },
        conyugueCargo: {
            value: '',
            isRequired: false,
            hasdata: false,
            require_msg: 'cargo es obligatorio',
            validate_msg: ''
        },
    },
    academy_information: {
        idInstitucionEducativa1: {
            value: '',
            isRequired: true,
            hasdata: false,
            require_msg: 'Institución Educativa es obligatorio',
            validate_msg: ''
        }
    },

    //Validado
    working_information: {
        laboralNoLaborando: {
            value: '',
            isRequired: false,
            hasdata: false,
            require_msg: '',
            validate_msg: ''
        },
        laboralCentroTrabajo: {
            value: '',
            isRequired: true,
            valueValidate: '',
            hasdata: false,
            require_msg: 'Centro de trabajo es obligatorio',
            validate_msg: ''
        },
        laboralFechaInicio: {
            value: '',
            isRequired: true,
            valueValidate: '',
            hasdata: false,
            require_msg: 'Fecha de inicio es obligatorio',
            validate_msg: ''
        },
        laboralRubroEmpresa: {
            value: '',
            isRequired: true,
            valueValidate: "",
            hasdata: false,
            require_msg: 'Actividad o Rubro es obligatorio',
            validate_msg: ''
        },
        laboralNroEmpleados: {
            value: '',
            isRequired: true,
            valueValidate: "",
            hasdata: false,
            require_msg: 'Nro de Empleados es obligatorio',
            validate_msg: ''
        },
        laboralArea: {
            value: '',
            isRequired: true,
            valueValidate: '',
            hasdata: false,
            require_msg: 'Area es obligatorio',
            validate_msg: ''
        },
        laboralCargo: {
            value: '',
            isRequired: true,
            valueValidate: '',
            hasdata: false,
            require_msg: 'Cargo es obligatorio',
            validate_msg: ''
        },
        laboralDescripcionCargo: {
            value: '',
            isRequired: true,
            valueValidate: '',
            hasdata: false,
            require_msg: 'Descripción de Cargo es obligatorio',
            validate_msg: ''
        },
        laboralDireccion: {
            value: '',
            isRequired: true,
            valueValidate: '',
            hasdata: false,
            require_msg: 'Dirección es obligatorio',
            validate_msg: ''
        },
        laboralTelefono: {
            value: '',
            isRequired: true,
            valueValidate: '',
            hasdata: false,
            require_msg: 'Teléfono es obligatorio',
            validate_msg: ''
        },
        laboralEmail: {
            value: '',
            isRequired: true,
            valueValidate: '',
            hasdata: false,
            require_msg: 'Email es obligatorio',
            validate_msg: 'Ingresa un email correcto'
        },
    },

    other_working_information: {
        nombreEmpresa: {
            isRequired: true,
            valueValidate: '',
            require_msg: 'Nombre de empresa es obligatorio'
        },
        idRubroEmpresa: {
            isRequired: true,
            valueValidate: '',
            require_msg: 'Actividad de la Empresa'
        },
        fechaDesde: {
            isRequired: true,
            valueValidate: '',
            require_msg: 'Fecha Desde - Hasta es obligatorio'
        },
        fechaHasta: {
            isRequired: true,
            valueValidate: '',
            require_msg: 'Fecha Desde - Hasta es obligatorio'
        },
        area: {
            isRequired: true,
            valueValidate: '',
            require_msg: 'Área es obligatorio'
        },
        cargo: {
            isRequired: true,
            valueValidate: '',
            require_msg: 'Cargo es obligatorio'
        },
        descripcionCargo: {
            isRequired: true,
            valueValidate: '',
            require_msg: 'Cargo es obligatorio'
        },
    }
}

export default FormFields;